import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getIsRoomInfoAvailable } from '../../store/domains/room-info/selectors';

export default function OnlyWithRoomInfoHuita(ComposedComponent) {
  class OnlyWithRoomInfo extends React.PureComponent {
    render() {
      const { hasInfo, ...rest } = this.props;
      return hasInfo ? <ComposedComponent {...rest} /> : null;
    }
  }
  OnlyWithRoomInfo.propTypes = {
    hasInfo: PropTypes.bool.isRequired,
  };
  const mapStateToProps = (state) => ({
    hasInfo: getIsRoomInfoAvailable(state),
  });

  return connect(mapStateToProps)(OnlyWithRoomInfo);
}
